import axios from 'axios'
import store from '../store/index'
import * as types from '../store/types'

// axios 配置
axios.defaults.timeout = 5000
axios.defaults.baseURL = ''

// http request 拦截器
axios.interceptors.request.use(
  config => {
    var accessToken = window.localStorage.getItem(types.STORAGE_ACCESS_TOKEN)
    if (accessToken) {
      config.headers.Authorization = `JWT ${accessToken}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 400:
        case 401:
          // console.log(error)
          // console.log(error.response.data)
          if ('messages' in error.response.data) {
            // console.log('token 过期')
            store.dispatch(types.USER_REFRESH)
          } else {
            // console.log(' refresh token 失效')
            store.dispatch(types.USER_LOGOUT)
          }
      }
    }
    return Promise.reject(error.response.data)
  }
)

export function fetch (url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data)
      })
      .catch(err => {
        // console.log(err)
        reject(err)
      })
  })
}

export function post (url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data)
      },
      err => {
        // console.log(err)
        reject(err)
      }
    )
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/utils/http.js